import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import React from "react";

function DeleteModal(props) {
  const { t } = useTranslation();
  const { show, onClose, ID, identifier, deleteType } = props;
  const axiosPrivate = useAxiosPrivate();


  const handleDelete = async () => {
    try {
      if (deleteType === "grave") {
        await axiosPrivate.delete(
          `/graves/${ID}`
        );
      } else if (deleteType === "departed") {
        await axiosPrivate.delete(
          `/departed/${ID}`
        );
      }
      onClose(deleteType);
    } catch (error) {
      alert(`${t("deleteFailedMesage") + error.message}`);
      console.error("Failed to delete:", error);
    }
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} className={"delete-modal"}>
      <Modal.Body
        className={"text-center pt-4 mt-2"}
      >
        {t("surelyDeleteText")} {identifier} ?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleDelete}
          className={"shadow border-0 p-2 px-4 w-47"}
        >
          {t("yes")}
        </Button>
        <Button
          variant="secondary"
          onClick={onClose}
          className={"shadow border-0 p-2 px-4 w-47"}
        >
          {t("no")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
